
import card from './components/card.vue'
import { firstAddressTaskAdd, endPanduan } from '@/api/lalisai'
import addressPicker from '@/views/components/address-picker2'
import { getAddressDefault, addAddress, editAddress } from '@/api/user'

import cookie from 'vux/src/tools/cookie/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
directives: {
TransferDom
},
components: {
XInput,
XButton,
Group,
addressPicker,
card
},
name: 'fillin',
props: {},
data () {
return {
flag: false,
title: '填写收货信息',
rule: false,
showAddress: false,
personObj: {
NAME: '',
ADDRESS: '',
MOBILE: '',
CITYID: '',
COUNTYID: '',
PROVINCEID: ''
},
addressValue: [],
addressid: '',
partyId: '1',
unitname: ''
}
},
created () {
this.getAddress()
},
mounted () {
},
watch: {
addressValue: {
handler: function (val) {
this.personObj.PROVINCEID = val[0]
this.personObj.CITYID = val[1]
this.personObj.COUNTYID = val[2]
},
deep: true
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
methods: {
addlog () {
firstAddressTaskAdd({
accountid: this.accountid,
partyId: '1'
})
},

getAddress () {
getAddressDefault({
accountid: this.accountid
}).then(res => {
if (res.status == 'suc') {
if (res.returnValue !== '') {
this.defautAddress = true
this.personObj = res.returnValue
console.log(this.personObj)
this.addressid = res.returnValue.ID

this.$set(
this.addressValue,
0,
res.returnValue.PROVINCEID.toString()
)
this.$set(this.addressValue, 1, res.returnValue.CITYID.toString())
this.$set(this.addressValue, 2, res.returnValue.COUNTYID.toString())
this.personObj.ADDRESS = res.returnValue.ADDRESS
} else {
this.defautAddress = false
}
} this.flag = true
console.log(this.addressValue)
})
},

sumbit () {
if (this.personObj.NAME === '') {
this.$vux.toast.text('请填写姓名！')
return false
}
if (this.personObj.MOBILE === '') {
this.$vux.toast.text('请填写手机号码！')
return false
}
if (this.addressValue === '') {
this.$vux.toast.text('请选择地区')
return false
}
if (this.personObj.ADDRESS === '') {
this.$vux.toast.text('请填写收货地址！')
return false
}




if (!/^\d{11}$/.test(this.personObj.MOBILE)) {
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
endPanduan({
partyId: this.partyId
}).then(res => {
if (res.obj) {
this.addlog()
}
})
if (!this.defautAddress) {
addAddress({
accountid: this.accountid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE,
address: this.personObj.ADDRESS,
provinceid: this.personObj.PROVINCEID,
cityid: this.personObj.CITYID,
countyid: this.personObj.COUNTYID,
isdefault: 1
}).then(data => {
if (data.status == 'suc') {
this.showAddress = false
this.$vux.toast.text('提交成功!')
this.$router.push({ name: 'lalisaiIndex' })
}
})
} else {
editAddress({
addressid: this.addressid,
accountid: this.accountid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE,
address: this.personObj.ADDRESS,
provinceid: this.personObj.PROVINCEID,
cityid: this.personObj.CITYID,
countyid: this.personObj.COUNTYID,
isdefault: 1,
remark: this.unitname
}).then(data => {
if (data.status == 'suc') {
this.showAddress = false
this.$vux.toast.text('提交成功!')
this.$router.push({ name: 'lalisaiIndex' })
}
})
}
}
}
}
